// extracted by mini-css-extract-plugin
export default {"container":"ProductContainer_container__ntb+u"};